import { download } from "../../components/AssetLibrary";
import { InlineImage } from "../../components/InlineImage";

/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
function Titania() {
  return (
    <div>
      <div className="box light">
        <div className="row">
          <h1>Titania (2007)</h1>
          <InlineImage width={400} image="spellen/titania/2007_titania.png" />

          <InlineImage width={100} image="spellen/titania/2007_titania_logo.png" border={false} />

          <p>
            In 2007 organiseerde wij (met zijn tweeën) een op Wie is de Mol geïnspireerd spel genaamd "Titania". Dat spel duurde een hele week. Ter voorbereiding hadden we het
            gebied maanden eerder al 'verkend' in een korte vakantie van een aantal dagen.
          </p>
          <p>
            Verdeeld over 6 dagen werden er 18 opdrachten gedaan; iedere dag 3 opdrachten. Dit was verreweg het meest intensieve spel dat ik ooit georganiseerd heb. Iedere dag 3
            opdrachten, en die voorbereiden, is gewoon loodzwaar. En doordat je 's nachts al aan het nadenken bent over de opdrachten van de volgende dag kun je de slaap moeilijk
            vatten. Desalniettemin was het een onvergetelijke ervaring.
          </p>
        </div>
      </div>
      <div className="box main">
        <div className="row">
          <h1>Korte uitleg</h1>
          <InlineImage width={400} image="spellen/titania/2007_titania_kaart.jpg" />
          <p>
            Titania is een denkbeeldig land opgedeeld in 6 gewesten. De spelers strijden om de troonopvolging van koning Corsiva van Rijckevorsel van Kessel en daarmee om de
            heerschappij over het prachtige land Titania. Ieder gewest wordt vertegenwoordigd door 2 spelers. Iedere speler weet van zichzelf tot welke gewest hij of zij behoort,
            maar weet dit van geen enkele andere speler (inclusief de speler uit hetzelfde gewest). De spelers uit hetzelfde gewest spelen samen; hun individuele scores worden bij
            elkaar opgeteld en het gewest met de meeste punten wint de troonopvolging.
          </p>
          <p>
            In het spel kunnen punten en edelstenen verdiend worden. Verdiende punten worden opgeteld bij de individuele score van de speler. Met edelstenen kunnen punten gekocht
            worden of stukjes informatie over een bepaald gewest. Over ieder gewest zijn er 22 stukjes informatie te verzamelen. Pas als een speler alle 22 stukjes informatie van
            een bepaald gewest compleet heeft kan de speler deze inleveren en krijgt daar punten voor terug.
          </p>
          <p>
            De spelers komen dagelijks bij de spelleiding om stukjes informatie te kopen, te laten controleren en om in te ruilen voor punten. Ook moeten de spelers raden welke
            spelers uit welk gewest komen, waarmee eveneens punten te verdienen zijn. De spelers zijn dus continu op zoek naar informatie over de gewesten en over welke spelers tot
            welk gewest behoren.
          </p>
          <p>
            Iedere dag zijn er 3 opdrachten, waarbij punten te verdienen zijn en edelstenen te vinden. Bij iedere opdracht is er echter 1 gewest uitgesloten van deelname; zij zijn
            tijdens die opdracht in feite 'de Mol'. Spelers van dat gewest kunnen geen punten verdienen, maar wel edelstenen vinden. Omdat zij zelf toch geen punten kunnen
            verdienen is het zaak ervoor te zorgen dat de andere spelers ook geen punten verdienen. Maar wel een beetje subtiel, want de informatie uit welke gewest je komt levert
            de anderen ook weer punten op.
          </p>
        </div>
      </div>

      <div className="box light">
        <div className="row">
          <h1>Opdracht 1 - De driehoek</h1>
          <InlineImage width={400} image="spellen/titania/opdracht1.jpg" />

          <h2>Korte Omschrijving</h2>
          <p>De spelers moeten in het bos het middelpunt van een (zeer grote) driehoek zien te bepalen en daar een 'schat' vinden.</p>

          <h2>Uitleg</h2>
          <p>
            De spelers worden verdeeld in 3 groepen van ieder 4 personen en naar een bos gebracht. De verdeling is door de spelleiding van te voren bepaald. De groep krijgt de
            uitleg van het spel te horen, daarna worden ze naar hun startpunt gebracht. De deelnemers wordt vertelt dat de deelnemers in 3 groepen verdeeld zijn. Iedere groep heeft
            een specifieke locatie in het bos aangewezen gekregen. De drie punten liggen allen precies even ver af van een bepaalde locatie. Op die locatie ligt een schat verborgen
            in de grond. De inhoud van de schat mag behouden worden door de eerlijke vinder. De groepen moeten samenwerken om het middelpunt te bepalen. Daarna kan aan de
            spelleiding aangegeven worden dat men een poging wil doen. De spelleiding bepaald een vierkant met een oppervlak van 1 vierkante meter rondom dat punt. De groep krijgt
            vervolgens 10 minuten om binnen dat vierkant op zoek te gaan naar de schat. Met 12 personen binnen 1 vierkante meter zoeken is best “druk”, dus de groep moet in goed
            overleg bepalen wie waar en hoe lang mag zoeken. Indien men de schat niet vindt mag men daarna een nieuwe poging doen. Daarna mag men nog “vrij zoeken” gedurende 20
            minuten. In de kist liggen 3 edelstenen en 1 onderdeel van het recept wat ze in de volgende opdracht nodig gaan hebben. De gelukkige vinder mag zowel de edelstenen als
            het recept behouden. In de buurt van het plaats delict zijn nog een aantal losse edelstenen verstopt.
          </p>

          <h2>Download</h2>
          <p>Download hier de volledige opdracht: {download("titania/Opdracht 1 - De Driehoek.pdf", "Opdracht 1 - De Driehoek.pdf")}</p>
        </div>
      </div>

      <div className="box main">
        <div className="row">
          <h1>Opdracht 2 - Vuur maken en stokbrood baken</h1>
          <InlineImage width={300} image="spellen/titania/opdracht2.jpg" />

          <h2>Korte Omschrijving</h2>
          <p>Er moet vuur gemaakt worden en op dat vuur stokbrood gebakken worden.</p>

          <h2>Uitleg</h2>
          <p>
            De deelnemers moeten om te beginnen vuur maken. De spelleiding voorziet de teams van droog stro, hout, papier en wattenstaafjes. Daarnaast krijgen de deelnemers een
            stuk touw en een plankje met een ‘deuk’. Een methode is om een pees te maken van het touw, deze om een stok te binden en deze rond te laten draaien in het kuiltje van
            de plank. Daarbij ligt de ‘tondel’ ofwel brandbaar materiaal. Het eerste team dat vuur heeft gemaakt wint de beproeving. De teams die er na 1 uur nog niet in geslaagd
            zijn vuur te maken mogen na dat uur “vrij”vuur proberen te maken. Hierbij mogen alle middelen gebruikt worden zoals vuursteen, brillenglazen, etc. Alles is toegestaan,
            behalve mechanische objecten en “rechtstreekse” vuurmakers. Het team dat als eerste vuur gemaakt heeft wint deze deelopdracht. Het eerste team krijgt 4 punten, de
            tweede 2 punten, de derde 1 punt. Nadat het derde team ofwel vuur gemaakt heeft ofwel opgegeven heeft gaat het spel verder met stokbrood bakken. De teams moeten een
            stokbrood bakken op hun gemaakte vuurtje. Het stokbrood wordt geproefd door de spelleiding en die beslist welk team het lekkerste brood gebakken heeft. De ingrediënten
            en het recept zijn alleen niet zomaar beschikbaar. Het recept wordt in een x-tal stukken gescheurd. 1 helft heeft iemand bij een eerdere opdracht die dag weten te
            bemachtigen. De andere helft zit ``stiekem` bij het brandhout. Als gereedschap om het stokbrood mee te bakken mogen ze alleen houten stokken gebruiken die ze zelf uit
            het bos moeten halen. Op volgorde van lekkerheid krijgen de teams; 3, 2 en 1 punt.
          </p>

          <h2>Download</h2>
          <p>Download hier de volledige opdracht: {download("titania/Opdracht 2 - Vuur maken en stokbrood bakken.pdf", "Opdracht 2 - Vuur maken en stokbrood bakken.pdf")}</p>
        </div>
      </div>

      <div className="box light">
        <div className="row">
          <h1>Opdracht 3 - Nachttocht</h1>
          <InlineImage width={500} image="spellen/titania/opdracht3.jpg" />

          <h2>Korte Omschrijving</h2>
          <p>
            Bij deze opdracht moet de groep een toch volgen in het donker. Uiteindelijk moet men een x-tal vlaggetjes zien te vinden met daarop een letter die samen een woord
            vormen. Het woord moet binnen anderhalf uur geretourneerd zijn bij de spelleiding. Er mag maximaal 3 maal geraden worden. Een poging is geldig als daar tenminste twee
            personen achter staan.
          </p>

          <h2>Uitleg</h2>
          <p>
            Deze opdracht vindt plaats in het donker en wordt met zijn allen gespeeld. Verschillende deelnemers krijgen een lantaarn. De deelnemers moeten een route door het bos
            afleggen die gemarkeerd is met witte katoenen vlaggen. Men moet op zoek gaan naar vlaggetjes die in het bos opgehangen zijn of neergezet zijn. Op of bij ieder vlaggetje
            staat of ligt een beschrijving van de locatie van een ander vlaggetje. De routebeschrijving van vlag tot vlag is steeds anders. Uiteindelijk moet een woord gevormd
            worden met andere, kleinere, vlaggen die ze langs de beek vinden. Dit laatste weten ze echter niet van te voren. De spelleiding verzamelt alle kandidaten bij het hutje
            in het bos achter het huisje. Dit is het startpunt van de route. Ze krijgen beschikking over pen en papier, een kompas en verlichting. De groep krijgt van de
            spelleiding hun eerste opdracht, onder vlag 0 genoemd. De beschrijvingen die bij iedere vlag liggen zijn bijgevoegd in de aparte office bestanden. Locatie van de
            vlaggen:
          </p>

          <ul>
            <li>Vlag 0 - Krijgt de groep van Sigibald en Liesken in de hut. Stappen en kompas leiden naar vlag 1.</li>
            <li>Vlag 1 - In een nis onder de rotsen aan de rivier. Pijlen leiden naar vlag 2.</li>
            <li>Vlag 2 - Over het bruggetje, links langs de rivier in de grote boom. Kaartje met situatieschets leidt naar vlag 3.</li>
            <li>Vlag 3 - De uit hout gesneden stoel onder de vele rotsen. Aantal passen en gebruik kompas op bomen leidt naar vlag 4.</li>
            <li>Vlag 4 - De boom vanaf de twee berken. Stenen leiden naar vlag 5.</li>
            <li>Vlag 5 - Dikke boom aan de rand van de overgang naar loofbos. Reukspoor lijdt naar vlag 6.</li>
            <li>Vlag 6 - Bij de dam in de rivier. Weg loopt terug langs de beek naar huis. Het woord is “Welterusten”.</li>
          </ul>

          <h2>Download</h2>
          <p>Download hier de volledige opdracht: {download("titania/Opdracht 3 - Nachttocht.pdf", "Opdracht 3 - Nachttocht.pdf")}</p>
        </div>
      </div>

      <div className="box main">
        <div className="row">
          <h1>Opdracht 4 - Boogschieten</h1>
          <InlineImage width={400} image="spellen/titania/opdracht4.jpg" />

          <h2>Korte Omschrijving</h2>
          <p>Er wordt boog geschoten in teams van twee, waarbij de groep ingedeeld wordt op geschatte armkracht (man bij vrouw).</p>

          <h2>Uitleg</h2>
          <p>Men moet simpelweg boogschieten. Het gaat om het meest aantal punten. Spelers worden aan elkaar gekoppeld (door de teamleiding).</p>

          <h2>Download</h2>
          <p>Download hier de volledige opdracht: {download("titania/Opdracht 4 - Boogschieten.pdf", "Opdracht 4 - Boogschieten.pdf")}</p>
        </div>
      </div>

      <div className="box light">
        <div className="row">
          <h1>Opdracht 5 - Verkenningstocht</h1>
          <InlineImage width={400} image="spellen/titania/opdracht5.jpg" />

          <h2>Korte Omschrijving</h2>
          <p>
            De groep moet een survivalparcours volbrengen. 1 persoon is echter uitgesloten van deelname (telt niet om te bepalen of de opdracht geslaagd is) maar weet dat pas
            achteraf.
          </p>

          <h2>Uitleg</h2>
          <p>
            De groep moet het voorgestelde parcours volledig volbrengen; alle opdrachten dus. Echter de groep mag 1 persoon "uitsluiten" van deelname. Deze persoon telt dan dus
            niet mee voor de "einduitslag". Ieder individu kiest vooraf anoniem een speler waarvan hij wenst dat de uitslag niet meetelt. De deelnemer die de meeste stemmen
            gekregen heeft telt niet mee voor het bepalen of de opdracht geslaagd is. Deze informatie wordt in de ochtend verzameld, men moet de spelleiding melden welke deelnemer
            hij het minst hoog acht als het gaat om durf.
          </p>

          <h2>Download</h2>
          <p>Download hier de volledige opdracht: {download("titania/Opdracht 5 - Verkenningstocht.pdf", "Opdracht 5 - Verkenningstocht.pdf")}</p>
        </div>
      </div>
      <div className="box main">
        <div className="row">
          <h1>Opdracht 6 - De posten</h1>
          <InlineImage width={400} image="spellen/titania/opdracht6.jpg" />

          <h2>Korte Omschrijving</h2>
          <p>
            Bij deze opdracht moeten de deelnemers in kleine groepjes van 3 personen (4 groepen dus) langs diverse posten lopen. Telkens zijn er twee teams aan de beurt en hebben
            de andere twee “vrij”. In totaal zijn er 6 opdrachten, ieder team voert iedere opdracht uit. Er zijn dus in totaal 12 speelronden.
          </p>

          <h2>Uitleg</h2>
          <p>
            Bij deze opdracht moeten de deelnemers in kleine groepjes van 3 personen (4 groepen dus) langs diverse posten lopen. Er zijn in totaal 3 rondes. In iedere ronde zijn er
            steeds twee teams aan de beurt en hebben de andere twee “vrij”. Als de twee teams klaar zijn wisselen ze met de andere teams die dan de opdrachten binnen die ronde
            uitvoeren. In totaal zijn er 6 opdrachten, ieder team voert iedere opdracht uit.
          </p>

          <h3>Ronde 1 - Opdracht 1</h3>
          <p>
            Haal de munt uit de kist zonder kracht te zetten. Het kistje kan met enige ruwheid geopend worden maar het moet geopend kunnen worden zonder ook maar enige ruwheid te
            gebruiken. Jullie hebben 5 minuten de tijd. Deze opdracht gaat op tijd.
          </p>
          <h3>Ronde 1 - Opdracht 2</h3>
          <p>
            Kijk goed naar de volgende tekening. Kijk goed, en kijk lang genoeg. Wat zien jullie in het plaatje? De tijd gaat nu lopen. Jullie hebben maximaal 5 minuten. Deze
            opdracht gaat op tijd.
          </p>
          <h3>Ronde 2 - Opdracht 3</h3>
          <p>
            Op tafel staan twee glazen, 1 met wijn en 1 met water, beide glazen even gevuld. De spelleider zegt “let goed op” en neemt een lepel water en schept die bij de wijn en
            roert deze. Vervolgens neemt hij weer een lepel en schept een lepel wijn bij het water. “Zit er nu meer water bij de wijn, of meer water bij de wijn?” stelt hij.
            Antwoord; het maakt niet uit. Vervolgens krijgen de deelnemers te horen dat ze naar de volgende post mogen. Aldaar zullen ze 3 ("enkele") vragen mogen gaan stellen.
          </p>
          <h3>Ronde 2 - Opdracht 4</h3>
          <p>
            Graag wil ik van jullie het antwoord op de volgende vraag. Daarbij mogen jullie 2 vragen stellen. “Zij die arm zijn hebben het, zij die rijk zijn hebben het nodig maar
            zij die het eten zullen sterven” (Oplossing: Niets!). Jullie hebben 5 minuten de tijd.
          </p>
          <h3>Ronde 3 - Opdracht 5</h3>
          <p>
            De groep deelnemers krijgen 3 minuten de tijd om zoveel mogelijk water uit een emmer te vervoeren naar een andere. Daarbij mogen alleen voorwerpen gebruiken die men op
            dat moment “aan” heeft (dus geen voorwerpen). De hoeveelheid milliliters wordt na afloop gemeten.
          </p>
          <h3>Ronde 3 - Opdracht 6</h3>
          <p>
            Open dit cijferslot. Iedere 2 minuten kunnen jullie een hint halen die het aantal mogelijkheden beperkt. Die hint kunnen jullie krijgen in de vorm van een vraag. Die
            vraag zal ik echter alleen met ja, nee, of met een getal tussen 0 en 10 beantwoord. Vragen waarop dat niet mogelijk is beantwoord ik willekeurig. Bijvoorbeeld; is het
            getal hoger dan 5000? Beide sloten moeten geopend worden om de kist open te mogen maken. In de kist bevinden zich tevens 6 edelstenen. Jullie hebben maximaal 10
            minuten. De edelstenen moeten eerlijk verdeeld worden... De codes zijn: 070 en 010. Dit komt overeen met de tekst 'Arkula', wanneer a=0,b=1, ..., j=9,k=0,l=1,... etc.
            Dit komt terug in 1 van de spelhints; dat Arkula op sloten past.
          </p>

          <h2>Download</h2>
          <p>Download hier de volledige opdracht: {download("titania/Opdracht 6 - De posten.pdf", "Opdracht 6 - De posten.pdf")}</p>
        </div>
      </div>
      <div className="box light">
        <div className="row">
          <h1>Opdracht 7 - De veiling</h1>
          <InlineImage width={400} image="spellen/titania/opdracht7.jpg" />

          <h2>Korte Omschrijving</h2>
          <p>Er wordt informatie geveild met edelstenen uit eigen zak.</p>

          <h2>Uitleg</h2>
          <p>
            De deelnemers moeten plaatsnemen op een stoel in 2 of 3 rijen. Er vindt een veiling plaats; een veiling van informatie en er kan ingezet worden met edelstenen. Iedere
            speler krijgt voor aanvang van de veiling 5 edelstenen. Tevens mogen eerder in het spel vergaarde edelstenen gebruikt worden. Een bod uitbrengen doe je door je hand
            omhoog te steken en je “Titania” naam te roepen. Er kan geboden worden op de volgende informatie (hoogste bod telt):
          </p>
          <ul>
            <li>1 punt</li>
            <li>Exacte betekenis van 1 hint uit de Titania hints & tips naar keuze</li>
            <li>Informatie over een zelf gekozen gewest; bij welke opdracht dit gewest uitgesloten is.</li>
            <li>
              2 praktische tips over een specifieke opdracht (“Neem pen en papier mee bij opdracht 14 - Achtervolging te water” en “Bij de opdracht 12 - Strijd der companen, tweede
              opdracht waarbij dapperheid getest wordt; zorg dat je als laatste aan de beurt bent!”)
            </li>
            <li>Alle informatie van een speler naar keuze over een bepaald gewest naar keuze</li>
            <li>Informatie over de oorsprong van 1 speler naar keuze; uit welk gewest hij of zij afkomstig is.</li>
            <li>Korte samenvatting van 3 willekeurige opdrachten naar keuze</li>
            <li>2 stukjes informatie naar keus van ieder gewest</li>
            <li>10 edelstenen</li>
          </ul>
          <p>Alle informatie wordt uiteraard persoonlijk medegedeeld.</p>

          <h2>Download</h2>
          <p>Download hier de volledige opdracht: {download("titania/Opdracht 7 - De veiling.pdf", "Opdracht 7 - De veiling.pdf")}</p>
        </div>
      </div>
      <div className="box main">
        <div className="row">
          <h1>Opdracht 8 - Het amulet van Ta Whoo</h1>
          <InlineImage width={400} image="spellen/titania/opdracht8-2.jpg" />
          <h2>Korte Omschrijving</h2>
          <p>De groepen moeten een schat zien te vinden die voorzien is van een slot. Zowel de locatie als de cijfercombinatie moeten ze zien te ontdekken.</p>
          <h2>Uitleg</h2>
          <p>
            Ergens in het bos ligt een kist verstopt. In die kist bevindt zich het amulet van Ta Whoo. Dit is een schorpioen in glas. De kist is voorzien van twee 3-cijferige
            sloten. De kist moet gevonden worden, ter plekke opengemaakt en het amulet moet naar de spelleiding gebracht worden. Het eerste team dat dit lukt wint 4 punten per
            persoon en mag daarnaast de inhoud van de kist (op het amulet na) behouden.
          </p>
          <p>
            Het kan natuurlijk goed zijn dat meerdere groepen tegelijkertijd de locatie vinden, of dermate vlak na elkaar dat de andere groep de code nog niet gekraakt heeft. De
            eerste persoon die de kist vindt tikt deze aan. Dit geeft die persoon het recht als eerste verschillende codes te proberen. Zodra een speler van een andere groep de
            locatie ook heeft gevonden tikt deze de kist eveneens aan en draait de daarbij liggende zandloper om. Dit geeft het recht om na het verstrijken van de zandloper code te
            gaan proberen. De zandloper wordt dan wederom omgedraaid waarna de eerste persoon weer mag proberen. Vindt ook een persoon van de derde groep de kist dan tikt ook deze
            de kist aan. De zandloper die dan al loopt wordt afgemaakt en het team wat “aan de beurt” was is eerst aan de beurt. Pas nadat weer een volledige zandloper verstreken
            is mag de nieuwe groep proberen. Ten alle tijde mag de kist niet verplaatst worden. Om dit verhaal te verduidelijken liggen deze regels ook bij de kist.
          </p>
          <p>
            Zowel de locatie als de code zijn in het begin onbekend. De 3 groepen krijgen ieder een beschrijving van een bepaalde locatie. Op deze plek zullen zij meer informatie
            vinden. Hiermee stopt de uitleg van het spel.
          </p>
          <p>
            Op die locatie vinden zij een envelop met een brief. In die brief wordt 1 cijfer en positie genoemd en een aantal zinsneden. Het cijfer is onderdeel van de 2
            3-cijferige codes die ze zoeken. Ze beschikken in totaal over 3 van de 6 cijfers, twee van het ene slot en 1 van het andere. Daarmee is het laatste cijfer van het
            eerste slot snel te vinden. De laatste twee cijfers vinden van het tweede slot is een stuk lastiger. Maar voor de oplettende Titaan vormt de cijfercode een woord,
            namelijk Ta Whoo:
          </p>
          <p>a=0, b=1, c=2, d=3, e=4, f=5, g=6, h=7, i=8, j=9, k=0, l=1, m=2, n=3, o=4, p=5, q=6, r=7, s=8, t=9, u=0, v=1, w=2, x=3, y=4, z=5</p>
          <p>Codes 902 700 vormen dus tezamen TAW HOO.</p>
          <p>
            De zinsneden vormen tezamen met de zinsneden van de andere teams een beschrijving van de locatie van de kist. Bij deze opdracht is samenwerken dus een must. Maar
            daarnaast wil men ook niet teveel informatie kwijt.
          </p>
          <p>De zinsdelen die de groepen krijgen zijn:</p>
          <div className="table-container">
            <table>
              <tbody>
                <tr>
                  <th>Groep 1</th>
                  <th>Groep 2</th>
                  <th>Groep 3</th>
                </tr>
                <tr>
                  <td>Volg het onverharde pad</td>
                  <td>gedurende ruim 100m</td>
                  <td>in zuidelijke richting.</td>
                </tr>
                <tr>
                  <td>Sla af naar rechts</td>
                  <td>voor de grote lichte</td>
                  <td>steen en ga het bos in.</td>
                </tr>
                <tr>
                  <td>Vind het gangpad</td>
                  <td>waarin veel stronken liggen</td>
                  <td>en zoek aan je rechterhand.</td>
                </tr>
                <tr>
                  <td>De kist ligt</td>
                  <td>op een lichtere plek</td>
                  <td>bij een bemoste stronk.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <h2>Download</h2>
          <p>Download hier de volledige opdracht: {download("titania/Opdracht 8 - Het amulet van Ta Whoo.pdf", "Opdracht 8 - Het amulet van Ta Whoo.pdf")}</p>
        </div>
      </div>
      <div className="box light">
        <div className="row">
          <h1>Opdracht 9 - Stimulatie van de geest</h1>
          <InlineImage width={400} image="spellen/titania/opdracht9.jpg" />

          <h2>Korte Omschrijving</h2>
          <p>Bij dit spel worden de spelers in vier teams verdeeld. Ieder team krijgt 4 opdrachten waarvoor "verstand" nodig is.</p>

          <h2>Uitleg</h2>
          <p>Het spel bestaat uit 4 opdrachten, ieder team doet iedere opdracht 1 maal.</p>

          <h3>Opdracht 1</h3>
          <p>
            Vlak na het ontbijt van deze dag heeft iedere deelnemer 4 "items" af moeten staan. 1 van deze items is hun heraldiek. De 3 andere moeten items zijn waarvan jou partner
            je zou kunnen herkennen. Dit kan zijn een schoen, een sok, wat ze zelf willen. Welk voorwerp ze afstaan moet echter wel geheim blijven, maar wel echt van hun zelf zijn.
            Van deze voorwerpen tezamen wordt een Sudoku gemaakt. In de Sudoku worden de naam en de items verwerkt van alle resterende deelnemers, dit zijn dus 4 maal 9 items. De
            getallen in de Sudoku komen overeen met voorwerpen van 1 en dezelfde persoon. Er wordt vermeld welke heraldieken overeen komen met welke getallen. Daarnaast krijgt men
            pen en papier. Het is dus zaak uit te zoeken welke items van wie zijn en bij welke heraldiek ze horen. Op die manier kan de Sudoku opgelost worden. Men heeft hiervoor
            60 minuten de tijd. Locatie: in het stukje bos.
          </p>

          <h3>Opdracht 2</h3>
          <p>
            Er wordt een legpuzzel van 500 stukjes neergelegd. Deze moet zo snel mogelijk gelegd worden. Maximale tijd: 30 minuten. Indien men de puzzel af heeft binnen die 30
            minuten dan telt de snelste tijd. Indien langzamer dan worden het aantal nog te leggen stukjes geteld. Locatie: buiten op de tafels.
          </p>

          <h3>Opdracht 3</h3>
          <p>
            Een weegschaal staat op tafel. Daarnaast liggen 5 voorwerpen. De groep moet als eerste de 5 voorwerpen rangschikken naar gewicht. Hiervoor heeft men maximaal 5 minuten.
            De voorwerpen mogen niet aangeraakt worden (blazen e.d. is wel toegestaan). Daarna moeten alle voorwerpen met de weegschaal gewogen worden. Het is de bedoeling de
            weging zo nauwkeurig mogelijk te doen. Het zwaarste voorwerp is hier zwaarder dan de som van de gewichtjes bij de weegschaal.
          </p>

          <h3>Opdracht 4</h3>
          <p>
            De deelnemers worden allen geblinddoekt. Vervolgens krijgen ze een aantal zaken te proeven en te ruiken. Ze moeten raden wat het is. De te ruiken/proeven/voelen zaken:
            Voelen: aardappel geschild in een vreemde vorm, suiker, en kaas Ruiken: rijstwafel, cake en Sinaasappelsap Proeven:courgette, gele paprika en suikerwater Het aantal
            goed geraden voorwerpen (de groep geeft gezamenlijk 1 antwoord) wordt geteld. De groep met de meeste juiste antwoorden wint.
          </p>

          <h2>Download</h2>
          <p>Download hier de volledige opdracht: {download("titania/Opdracht 9 - Stimulatie van de geest.pdf", "Opdracht 9 - Stimulatie van de geest.pdf")}</p>
        </div>
      </div>
      <div className="box main">
        <div className="row">
          <h1>Opdracht 10 - De wapenmaker</h1>
          <InlineImage width={400} image="spellen/titania/opdracht10.jpg" />

          <h2>Korte Omschrijving</h2>
          <p>
            De spelers worden in 3 groepen van 4 verdeeld. Ieder team krijg de opdracht om een boog en daarna een katapult te maken waarmee ze zover mogelijk moeten proberen te
            schieten.
          </p>

          <h2>Uitleg</h2>
          <p>
            Patira, het land waar het Titaanse leger gevestigd is kent vele helden. Ofschoon de laatste oorlog in Titania zeer lang geleden is en er geen oorlog te verwachten valt
            is het een goede zaak altijd op het ergste voorbereid te zijn. Daarom is het de taak van de deelnemers aan te tonen dat ze de kunst van het wapenmaken afdoende
            beheersen. Twee wapens zullen ze moeten gaan maken; een boog en een katapult. De team die het verste schiet met de boog en met de katapult wint de opdracht.
          </p>

          <h3>Opdracht 1 - Maak een boog</h3>
          <p>
            Ieder team moet een boog produceren. Met deze boog moet men een pijl zover mogelijk zien te schieten. Ieder team mag 3 pogingen doen waarvan het beste schot telt. De
            afstand wordt gemeten met een lang touw. Het team dat het verst komt wint de opdracht.{" "}
          </p>

          <h3>Opdracht 2 - Maak een katapult</h3>
          <p>
            Ieder team moet een katapult maken. Ook hier geldt weer dat men zo ver mogelijk moet zien te schieten en dat ieder team 3 maal mag schieten. Als kogel wordt hier
            gebruikt de beruchte “vogelbol”, hetgeen een vuurbal moet voorstellen.{" "}
          </p>

          <h2>Download</h2>
          <p>Download hier de volledige opdracht: {download("titania/Opdracht 10 - De wapenmaker.pdf", "Opdracht 10 - De wapenmaker.pdf")}</p>
        </div>
      </div>
      <div className="box light">
        <div className="row">
          <h1>Opdracht 11 - De zonnewijzer</h1>
          <InlineImage width={400} image="spellen/titania/opdracht11.jpg" />

          <h2>Korte Omschrijving</h2>
          <p>De groep moet gezamenlijk een zonnewijzer maken die gedurende 2 uren de juiste tijd aangeeft.</p>

          <h2>Uitleg</h2>
          <p>
            De groep moet een zonnewijzer maken die gedurende 2 uur (om 15:00 en om 16:00) de tijd correct aangeeft. Daartoe moeten ze alle horloges inleveren. Ze krijgen
            vervolgens een zandloper waarmee ze de tijd kunnen meten. De zandloper bestaat uit 3 delen die elk een verschillend aantal minuten meet. De informatie die de groep
            krijgt is dat de zandloper ontworpen is om hele minuten te meten. Iedere loper heeft echter een kleine afwijking, twee ervan hebben een afwijking van 10 seconden en één
            van 20 seconden. Om afwijkingen te beperken moet er af en toe op de loper getikt worden om hem goed door te laten lopen.
          </p>
          <p>
            Met de zandloper moeten ze zien 1 heel uur af te meten. De spelleiding meldt het tijdstip waarop het 2 uur is. Vervolgens kunnen ze die zandloper gebruiken om 3 en 4
            uur af te meten. Met dat gegeven moeten ze een zonnewijzer produceren die op 14:00 en 15:00 de juiste tijd aangeeft. Die tijd moet afgelezen kunnen worden door de
            spelleiding en 1 of 2 deelnemers een dag later. De groep kiest 1 of 2 deelnemers die de dag erop precies om 16:00 en 17:00 aan de hand van de zonnewijzer moeten roepen
            'Het 16e uur is NU aangebroken in Titania' en 'Het 17e uur is NU aangebroken in Titania'. De groep krijgt een half uur de tijd een strategie te bepalen en om die
            deelnemer(s) te kiezen. De opdracht begint dus om 13:30.
          </p>
          <p>
            Terwijl ze de zonnewijzer aan het maken zijn moeten ze de opdracht van die avond alvast voorbereiden. Om iets over 2 wanneer de zandlopermeting gestart is zal de
            spelleiding al iets vertellen over de opdracht van die avond, waarbij een klucht opgevoerd moet gaan worden. De groep wordt alvast in 3en gedeeld. Er wordt vertelt wat
            die klucht in zal houden. De deelnemers schrijven als eerste alvast het script voor hun klucht voor die avond. Na ongeveer een uur wisselt men en krijgt iedere groep de
            klucht van een andere groep te lezen. Daarbij kunnen ze voorbereidingen treffen om de juiste geluiden te kunnen produceren.
          </p>
          <p>
            Het controleren van de zonnewijzer gebeurd pas de volgende dag. Daartoe moeten de geselecteerde deelnemers op de afgesproken tijdstippen 16:00 en 17:00 de afgesproken
            zin roepen, in aanwezigheid van de spelleiding. De spelleiding meet de exacte tijd maar vertelt niet direct of het goed is. Pas om 17:00 wordt de uitslag bekend gemaakt
            en daarmee de punten verdeeld. De spelleiding bepaalt de som van de afwijkingen van de twee uren. Indien de som kleiner is dan 3 minuten ontvangt de groep 3 punten per
            persoon (m.u.v. de mollen). Is de afwijking minder dan 5 minuten dan ontvangt de groep 2 punten per persoon, en 7 minuten dan 1 punt per persoon.
          </p>

          <h2>Download</h2>
          <p>Download hier de volledige opdracht: {download("titania/Opdracht 11 - De zonnewijzer.pdf", "Opdracht 11 - De zonnewijzer.pdf")}</p>
        </div>
      </div>
      <div className="box main">
        <div className="row">
          <h1>Opdracht 12 - Strijd der companen</h1>
          <InlineImage width={400} image="spellen/titania/opdracht12.jpg" />

          <h2>Korte Omschrijving</h2>
          <p>Dit spel is een verzameling van 3 kleinere spelen waarbij uiteindelijk de puntenverdeling individueel is. Acteertalent, creativiteit en dapperheid worden beproefd.</p>

          <h2>Uitleg</h2>
          <p>Bij dit spel worden allerlei verschillende vaardigheden van de deelnemers getest.</p>
          <h3>Acteertalent</h3>
          <p>
            Om het acteertalent te testen wordt de groep in 3en gedeeld. Dit mag naar eigen inzicht verdeeld worden. Telkens is 1 groep aan de beurt terwijl de rest toekijkt. Van
            de groep die aan de beurt is komt telkens 1 persoon naar voren naar een tafel waar een vreemd voorwerp op ligt waarvan ze de werking uit moeten zullen leggen. Slechts 1
            van hun groep weet echter waartoe het voorwerp dient. Het is de taak van de overige groepsleden om de toehoorders te misleiden en hen doen te geloven dat zij degene
            zijn die weten wat het voorwerp is. De persoon die wel weet wat het is is overigens verplicht deze kennis te delen met het publiek.
          </p>

          <h3>Creativiteit</h3>
          <p>
            De groep wordt wederom in 3en gesplitst, naar keuze van de groep zelf. Iedere groep krijgt een ‘onderwerp’ voor een klucht. De klucht moet beknopt zijn (maximaal 20
            min. duren) maar ook een ‘moraal van het verhaal’ bevatten. Het script en het geluid zijn de middag ervoor al voorbereidt. De groepen krijgen nog een half uur de tijd
            om hun kluchten voor te bereiden. Ze hebben twee kluchten om voor te bereiden; die waarvan ze het script geschreven hebben en die waarvan ze het geluid verzorgen.
          </p>
          <p>De onderwerpen van de klucht zijn:</p>
          <ul>
            <li>Ontrouw</li>
            <li>Verhouding tussen de armen en de rijken</li>
            <li>Teveel eten en drinken</li>
          </ul>
          <p>Iedere klucht moet voldoen aan:</p>
          <ul>
            <li>Het moet een 'moraal van het verhaal' hebben.</li>
            <li>Het mag maximaal 20 minuten duren (de opvoering ervan).</li>
            <li>De klucht moet zo geschreven zijn dat er goede geluiden onder gezet kunnen worden.</li>
            <li>De klucht moet zo geschreven zijn dat de acteurs op basis van het script duidelijk weten wat ze moeten acteren.</li>
          </ul>

          <h3>Dapperheid</h3>
          <p>
            Bij dit spel wordt de dapperheid van een ieder op de proef gesteld. De spelers spelen ieder apart. De spelers zijn om beurt aan de beurt, maar het spel wordt
            publiekelijk gespeeld. De speler heeft een bedrag X in een kistje voor zich staan. Niemand heeft dit bedrag gezien. Het bedrag X is getrokken uit een reeks van 10
            bedragen. Die bedragen zijn bekend en zijn; 1, 10, 50, 100, 500, 1.000, 3.000, 10.000, 25.000 en 100.000 (som is 139.661).
          </p>
          <p>
            De speler begint met het openmaken van 2 kistjes. Daarna doet de spelleiding een bod op het kistje. De speler kan kiezen; dit bod aannemen of doorgaan. Bij acceptatie
            van het bod wint de speler het geboden bedrag en eindigt het spel. Wanneer de speler doorgaat worden er weer twee kistjes opengemaakt, enz. Het doel van de speler is
            uiteraard zoveel mogelijk te verdienen.
          </p>
          <p>Wanneer de speler na 8 geopende kistjes door will gaan, wordt 9 opengemaakt en is het spel dus over en moet de speler het bedrag in zijn kistje nemen. </p>
          <h2>Download</h2>
          <p>Download hier de volledige opdracht: {download("titania/.pdf", ".pdf")}</p>
        </div>
      </div>

      <div className="box light">
        <div className="row">
          <h1>Opdracht 13 - Flessenpost</h1>
          <InlineImage width={400} image="spellen/titania/opdracht13.jpg" />

          <h2>Korte Omschrijving</h2>
          <p>
            Sigibald en Lysken bevinden zich in het bos, beiden aan de rivier. Zij communiceren per flessenpost en koeriers. Het is van groot belang dat alle brieven heen en weer
            aankomen, en dat tegelijkertijd diverse opdrachten uitgevoerd worden. Het zal een chaos worden. En in die chaos bevinden zich 2 mollen die maar 1 doel hebben; de
            opdracht laten falen...
          </p>

          <h2>Uitleg</h2>
          <p>
            Sigibald bevindt zich helemaal stroomopwaarts bij de dam, Lysken beneden bij het huis jedoch beide langs de rivier. Sigibald communiceert met Lysken middels
            flessenpost, Liesken met Sigibald middels koeriers. De deelnemers spelen deze koeriers. Een bericht van Lysken naar Sigibald moet gebracht worden door de koeriers. Een
            bericht van Sigibald naar Lysken gaat per flessenpost. Het doel is eenvoudig; alle berichten moeten aankomen. In de flessenpost zit soms ook 1 of meer edelstenen
            verborgen. De edelsteen is voor de “eerlijke vinder”.
          </p>
          <p>
            Lysken en Sigibald geven ook opdrachten die uitgevoerd moeten worden. Deze opdrachten, het overbrengen van berichten door koeriers en het versturen van flessenpost via
            de rivier maken het een rommelig geheel. Verschillende groepjes zijn op dezelfde momenten met verschillende opdrachten bezig, toch moeten alle opdrachten volbracht
            worden en alle berichten aankomen. Wetende dat er 2 mollen in het spel zitten is het zaak om er achter te komen wie de boel probeert te 'flessen'.
          </p>
          <p>
            Zowel Lysken als Sigibald hebben beide 7 berichten die ze naar elkaar zenden. Zodra Sigibald het laatste bericht per flessenpost verstuurt blaast hij de fluit en zet de
            zandloper. Hij wacht dan nog 7 minuten en zal daarna geen berichten meer aannemen. Daarna loopt hij terug langs de rivier. Zodra hij Lysken bereikt is het spel helemaal
            afgelopen. Lysken en Sigibald evalueren dan of alle uitgedeelde opdrachten succesvol volbracht zijn en of dat alle berichten aangekomen zijn.
          </p>

          <h2>Download</h2>
          <p>Download hier de volledige opdracht: {download("titania/Opdracht 13 - Flessenpost.pdf", "Opdracht 13 - Flessenpost.pdf")}</p>
        </div>
      </div>

      <div className="box main">
        <div className="row">
          <h1>Opdracht 14 - Achtervolging te water</h1>
          <InlineImage width={400} image="spellen/titania/opdracht14.jpg" />

          <h2>Korte Omschrijving</h2>
          <p>De spelers gaan per 2 te water in een kano en hebben allen een getal op hun rug die de andere teams moeten zien te achterhalen.</p>

          <h2>Uitleg</h2>
          <p>
            Er worden teams gemaakt van 2 personen die allen met 1 kano te water gaan. Om te bepalen wie als eerste mag vertrekken wordt er gekeild. Ieder team kiest 1 speler uit
            die hieraan mee doet. Wie daarvan het verst komt “mag” als eerste weg. Dit wordt wel gemeld, maar niet de exacte uitleg van de opdracht, en dus het gegeven dat vroeg
            vertrekken nadelig is.
          </p>
          <p>
            De spelleiding vertrekt als eerste en gaat net uit zicht liggen. Als de spelleiding uit zicht is vertrekt de eerste groep vertrekt en gaat naar de spelleiding. De
            spelleiding legt de groep dan pas het spel uit en deelt de rugnummers uit die ze op hun rug moeten spelden. Zodra de spelleiding klaar is met deze groep blazen zij op
            een fluitje en de volgende groep mag vertrekken.
          </p>
          <p>
            Het doel van ieder team is om zoveel mogelijk rugnummers van andere teams te zien en te onthouden. Pen en papier is toegestaan, maar je moet het wel terplekke bij je
            hebben. Er is na de uitleg geen kans meer om een pen te bemachtigen.
          </p>
          <p>
            De laatste groep die vertrekt heeft aan de ene kant een voordeel omdat ze de laatste zijn. Aan de andere kant, de spelleiding zitten op hun hielen en die moet iedereen
            ten alle tijde voorblijven. Wie volledig achter de spelleiding terecht komt wordt gediskwalificeerd en kan geen punten meer verdienen.
          </p>
          <p>
            De kano’s mogen het water niet verlaten, nog mogen de personen de kano’s verlaten. Het spel eindigt bij het eindpunt. Zodra voet aan wal is gezet mag het rugnummer
            verwijderd worden. Een team wat een ander team ziet wat aan wal gegaan is, of wat geen rugnummer meer heeft mag ook zijn of haar rugnummer verwijderen. Dit brengt dus
            een soort van kettingreactie te weeg. Het spel eindigt wanneer de spelleiding aan wal gegaan is. Terplekke moeten de deelnemers per team de antwoorden geven. Ofwel;
            zoveel mogelijk rugnummers opnoemen. Voor ieder goed antwoord krijgt men een punt, voor ieder fout nummer gaat er een punt af.
          </p>
          <p>De rugnummers zijn: 87, 43, 31, 29, 38, 64, 56, 94, 15, 79, 41, 28</p>

          <h2>Download</h2>
          <p>Download hier de volledige opdracht: {download("titania/Opdracht 14 - Achtervolging te water.pdf", "Opdracht 14 - Achtervolging te water.pdf")}</p>
        </div>
      </div>

      <div className="box light">
        <div className="row">
          <h1>Opdracht 15 - De struikrovers</h1>
          <InlineImage width={400} image="spellen/titania/opdracht15.jpg" />

          <h2>Korte Omschrijving</h2>
          <p>
            Bij deze opdracht wordt de groep in 2en gedeeld; de struikrovers en de koeriers. De koeriers moeten edelstenen van A naar B brengen, de struikrovers moeten zien het
            transport ervan te onderscheppen.
          </p>

          <h2>Uitleg</h2>
          <p>
            De groep wordt in 2en gedeeld. De ene helft begint als zijnde koeriers van de koning, de andere helft als struikrovers. De koeriers moeten een aantal edelstenen van A
            naar B brengen, de struikrovers moeten die edelstenen zien te onderscheppen.
          </p>
          <p>
            De koeriers starten vanaf het huisje, hetgeen het beginpunt is. 1 persoon van de spelleiding blijft ten aller tijde bij dit huisje. Een andere persoon van de
            spelleiding bevindt zich ergens in het bos, op de locatie van het dorp waar de koeriers edelstenen vandaan moeten halen en terug moeten brengen naar het startpunt. De
            koeriers krijgen een kaart mee waarop de locatie van het dorp aangegeven staat. Deze kaart is niet van het volledige gebied maar alleen van de route die ze af moeten
            leggen naar het dorp. De koeriers mogen zich niet buiten de paden begeven, maar ze mogen wel een andere route kiezen.
          </p>
          <p>
            In het dorp krijgen de koeriers van de spelleiding een buidel en een rood lint om hun middel. Hiermee geven ze hun onkwetsbaarheid op. Dit is een omslagpunt in het
            spel, voordat een koerier een buidel bezit heeft een koerier het "initiatief" en is onkwetsbaar, daarna hebben de struikrovers het "initiatief" en is de koerier alles
            behalve onkwetsbaar. Het "initiatief" hebben houdt in dat je een tegenspeler mag tikken. Er zijn dan twee mogelijkheden:
          </p>
          <ol>
            <li>
              De koerier heeft geen buidel of een lege buidel bij zich, hij is dan onkwetsbaar. De koerier wint het in dat geval van de struikrover. De struikrover levert zijn
              struikrovers kaartje in bij de koerier en gaat terug naar het huisje. Daar moet hij 5 min. wachten alvorens hij het spel weer mag betreden.
            </li>
            <li>
              De koerier heeft een gevulde buidel (1 edelsteen of meer) bij zich. De struikrover wint in dat geval, op vertoning van zijn struikrovers kaartje. De koerier levert de
              buidel met inhoud in bij de struikrover en is uit het spel. De koerier gaat terug naar het huisje.
            </li>
          </ol>
          <p>
            Koeriers moeten het dorp bereiken om daar voorzien te worden van buidel en rood lint. Dit geeft aan dat ze niet meer het initiatief hebben. De koeriers hebben maximaal
            30 minuten de tijd om hun initiatief uit handen te geven. Na 30 minuten, of wanneer alle koeriers hun onkwetsbaarheid opgegeven hebben blaast de spelleiding op de fluit
            om dit aan te geven. De koeriers mogen pas edelstenen gaan vervoeren als alle koeriers hun initiatief opgegeven hebben. Een koerier mag maximaal 3 edelstenen vervoeren.
            In totaal moeten er 18 edelstenen vervoerd worden.
          </p>
          <p>
            De directe omgeving van het huisje en het dorp zijn veilig terrein voor de koeriers. Indien ze zich binnen een straal van ongeveer 15 meter bevinden kunnen zij
            "titania" roepen. De spelleiding antwoord daarop "veilig" om aan te geven dat ze inderdaad veilig zijn. De struikrovers mogen de koeriers dan niet meer tikken. Indien
            de spelleiding niet antwoord houdt dat in dat ze zich nog te ver van het dorp of huisje bevinden. Dit hoeft overigens niet, in de regel is dit alleen nodig als de
            koerier achternagezeten wordt door een struikrover. Verlaat een koerier de veilige zone dan roept de spelleiding “vrij”, maar alleen als er een struikrover in de buurt
            is.
          </p>
          <p>
            De koeriers mogen onderling edelstenen herverdelen, of terug gaan naar het dorp om edelstenen terug te brengen of juist bij te pakken. De struikrovers krijgen een
            kaartje mee van het hele gebied. Hiermee kunnen zij hun strategie bepalen. De struikrovers worden het bos ingestuurd 5 minuten voordat de koeriers vertrekken.
          </p>
          <p>
            Beide groepen krijgen voor aanvang van het spel 10 minuten voor overleg. In die tijd begeeft de spelleiding zich richting het dorp. Iedere speler krijgt een korte
            samenvatting van de spelregels mee. Struikrovers krijgen een struikroverkaartje mee en moeten hun kaproen dragen. De koeriers leveren hun buidel in bij de spelleiding
            die deze mee neemt naar het dorp, aldaar krijgen ze de buidel pas weer terug.
          </p>

          <h2>Download</h2>
          <p>Download hier de volledige opdracht: {download("titania/Opdracht 15 - De struikrovers.pdf", "Opdracht 15 - De struikrovers.pdf")}</p>
        </div>
      </div>

      <div className="box main">
        <div className="row">
          <h1>Opdracht 16 - Herken je gezellen</h1>
          <InlineImage width={400} image="spellen/titania/opdracht16.jpg" />

          <h2>Korte Omschrijving</h2>
          <p>
            De deelnemers moeten de uit pasfoto's geknipte onderdelen van het gezicht herkennen en plaatsen bij de juiste persoon en heraldiek. Ieder team krijgt hiervoor 20
            minuten de tijd.
          </p>

          <h2>Uitleg</h2>
          <p>
            Van iedere deelnemer zijn van te voren pasfoto's gemaakt. Hieruit zijn de ogen, neus, mond en oren geknipt. Van iedere deelnemer worden er zo 2 oren, 1 neus, 1 paar
            ogen en 1 mond verzameld. Deze worden gehutseld en in een bak gegooid. Ieder onderdeel is voorzien van een nummer. Hier aan kan de spelleiding achterhalen van wie het
            onderdeel is, de deelnemers hebben er niets aan.
          </p>
          <p>
            In 4 groepjes van 3 personen komen de groepjes achter elkaar bij de spelleiding. Op de tafel of grond liggen de diverse onderdelen uitgestald. Tevens liggen daar ook de
            wapens uitgestald. Ook liggen er papiertjes met de Titania namen van alle spelers.
          </p>
          <p>
            De opdracht is eenvoudig. De juiste onderdelen moeten bij de juiste wapens en de juiste naam geplaatst worden. Er mag niet teruggegaan worden naar het huisje om wat dan
            ook raad te plegen. De deelnemers moeten dus zelf achterhalen van wie welke heraldiek ook alweer was.
          </p>
          <p>De maximale tijd voor deze opdracht is 20 minuten.</p>

          <h2>Download</h2>
          <p>Download hier de volledige opdracht: {download("titania/Opdracht 16 - Herken je gezellen.pdf", "Opdracht 16 - Herken je gezellen.pdf")}</p>
        </div>
      </div>

      <div className="box light">
        <div className="row">
          <h1>Opdracht 17 - In de fietssporen van koning Corsiva</h1>
          <InlineImage width={400} image="spellen/titania/opdracht17.jpg" />

          <h2>Korte Omschrijving</h2>
          <p>
            De groep volgt per fiets een routebeschrijving die ze gekregen hebben. Onderweg vinden moeten zij in totaal 4 opdrachten vinden en die uit voeren. De fietstocht is
            gebonden aan tijd. De hoeveelheid te verdienen punten is gerelateerd een de hoeveelheid tijd die het kost. Hoe langer – hoe minder punten. Fout uitgevoerde opdrachten
            kosten ook tijd. De opdracht mogen ter plekke of onderweg uitgevoerd worden. De tijd stopt echter pas, uiteraard, wanneer de groep bij de spelleiding is en alle
            opdrachten uitgevoerd en ingeleverd heeft. Bij de posten zijn tevens weer edelstenen verstopt.
          </p>

          <h2>Uitleg</h2>
          <p>
            De groep krijgt een stuk uit het dagboek van Koning Corsiva. Dit document stamt uit een tijd dat de koning nog jong en verliefd was. Hij ondernam deze tocht te voet
            maar de groep krijgt beschikking over fietsen. De koning beschrijft zeer uitgebreid de route die hij nam naar de plek waar hij zijn geliefde ging ontmoeten. De
            beschrijving is van jaren geleden en misschien nu niet meer helemaal correct. Enige interpretatie van de gegevens is vereist. De groep moet exact dezelfde route
            afleggen als de koning jaren geleden. Onderweg zullen ze plekken gemarkeerd zien met dik touw. Dit betekent dat er in deze omgeving een opdracht verstopt ligt. Vind de
            opdracht en voer deze uit alvorens de tocht voort te zetten. Dit is een kans voor jullie om het hart van de koning beter te leren kennen. Voor hem is het een kans om
            jullie te laten zien hoe mooi het land is waar enkelen van jullie over gaan regeren.
          </p>
          <p>
            De groep mag zich niet opsplitsen. Er is een tijdslimiet aan deze tocht verbonden. De tijd van het laatste groepslid telt. Het aantal punten dat verdient kan worden is
            afhankelijk van de hoeveelheid tijd die men nodig heeft. Opdrachten die niet juist zijn uitgevoerd worden bestraft met extra tijd.
          </p>
          <p>
            De spelleiding vertrekt als eerste en de groep dient 15 minuten te wachten. Daarbij wordt de groep op het hart gedrukt niet te proberen vals te spelen. De spelleiding
            zegt zo zijn middelen te hebben om de tijd te controleren... Dit kan natuurlijk ook concreet gemaakt worden door dit te vragen aan de verhuurder van de bikes.
          </p>
          <p>Bij de eerste 3 posten zijn weer edelstenen verstopt.</p>

          <h2>Download</h2>
          <p>Download hier de volledige opdracht: {download("titania/Opdracht 17 - In de fietssporen van Corsiva.pdf", "Opdracht 17 - In de fietssporen van Corsiva.pdf")}</p>
        </div>
      </div>

      <div className="box main">
        <div className="row">
          <h1>Opdracht 18 - Slotspel</h1>
          <InlineImage width={400} image="spellen/titania/opdracht18.jpg" />

          <h2>Korte Omschrijving</h2>
          <p>
            Deze opdracht bestaat uit twee delen. In het eerste deel speelt men nog individueel, in het tweede deel zijn de gewesten bekend gemaakt en speelt men samen. De laatste
            punten worden verdeeld en de winnaar wordt bekend gemaakt...
          </p>

          <h2>Uitleg</h2>
          <p>
            Dit laatste spel bestaat uit 2 delen. In het eerste deel worden er veel vragen gesteld over informatie die ze verzameld hebben en over wat er die week gebeurd is.
            Voordat het tweede deel begint wordt bekend gemaakt wie bij elkaar horen. Daarna volgt een afval race waarin telkens 1 gewest afvalt totdat de winnaars uiteindelijk
            overblijven.
          </p>

          <h2>Download</h2>
          <p>Download hier de volledige opdracht: {download("titania/Opdracht 18 - Slotspel.pdf", "Opdracht 18 - Slotspel.pdf")}</p>
        </div>
      </div>
    </div>
  );
}

export default Titania;
